<div class="actions-container">
  <ul
    class="actions-list"
    (mouseleave)="mouseLeave()"
    (mouseover)="isMouseOver = true"
    [@flyInOut]="state"
  >
    <!-- RETURN ACTION-->
    <li
      *ngIf="actionModel.displayReturnButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="undo()"
      matTooltip="{{ actionModel.module + '.UTIL.BUTTONS.RETURN' | translate }}"
      matTooltipPosition="left"
    >
      <i class="fa material-icons white">undo</i>
    </li>

    <!-- GENERATE DOCUMENT -->
    <li
      *ngIf="actionModel.displayDownloadDocument"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="downloadDocument()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.DOWNLOAD_BILLING_STATEMENT'
          | translate
      }}"
      matTooltipPosition="left"
      id="downloadDocumentButton"
    >
      <i class="fa material-icons white" style="color: darkgreen !important;"
      >list_alt</i
      >
    </li>

    <!-- RETURN WITH CONFIRMATION-->
    <li
      *ngIf="actionModel.displayUndoConfirmButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="undoConfirm()"
      matTooltip="{{ actionModel.module + '.UTIL.BUTTONS.RETURN' | translate }}"
      matTooltipPosition="left"
    >
      <i class="fa material-icons white">undo</i>
    </li>

    <!-- CALENDAR UPDATE-->
    <li
      *ngIf="actionModel.displaySetOkNotification"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="massSetOkNotification()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.MASS_SET_OK_NOTIFICATION'
          | translate
      }}"
      matTooltipPosition="left"
    >
      <i class="fa material-icons warning">calendar_today</i>
    </li>

    <!-- Confirmation de DUPLICATION ACTION-->
    <li
      *ngIf="actionModel.displayDuplicationValidation"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="post()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.DUPLICATE' | translate
      }}"
      matTooltipPosition="left"
    >
      <i class="fa material-icons success">check</i>
    </li>

    <!-- Validation ACTION-->
    <li
      *ngIf="actionModel.displayValidationButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="validate()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.VALIDATE' | translate
      }}"
      matTooltipPosition="left"
    >
      <i class="fa material-icons success">check</i>
    </li>

    <!-- Validation ACTION-->
    <li
      *ngIf="actionModel.displayAllValidationButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="validateAll()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.VALIDATE' | translate
      }}"
      matTooltipPosition="left"
    >
      <i class="fa material-icons success">check</i>
    </li>

    <!-- AddNewRight ACTION-->
    <li
      *ngIf="actionModel.displayAddNewRightButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="AddNewRight()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.ADD_RIGHT' | translate
      }}"
      matTooltipPosition="left"
    >
      <i class="fa fa-check-square-o success" aria-hidden="true"></i>
    </li>

    <!-- Submit to Validation ACTION-->
    <li
      *ngIf="actionModel.displaySubmitToValidationButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="!isAlreadyClick() ? submitToValidation() : null"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.SUBMIT_TO_VALIDATION' | translate
      }}"
      matTooltipPosition="left"
    >
      <i class="fa material-icons success">check</i>
    </li>

    <!-- Submit to Validation by mail ACTION-->
    <li
      *ngIf="actionModel.displaySubmitToValidationByMailButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="!isAlreadyClick() ? submitToValidationByMail() : null"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.SUBMIT_TO_VALIDATION' | translate
      }}"
      matTooltipPosition="left"
      positionStyle="fixed"
    >
      <i class="fa material-icons more-dark-blue">mail</i>
    </li>

    <!-- SEND EMAIL BUTTON -->
    <li
      *ngIf="actionModel.displayEmailButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="sendEmail()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.SEND_EMAIL' | translate
      }}"
      matTooltipPosition="left"
      id="sendMailButton"
    >
      <i
        class="fa material-icons white"
        style="color: palevioletred !important;"
      >email</i
      >
    </li>

    <!-- DELETE ACTION-->
    <li
      *ngIf="actionModel.displayDeleteButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="delete()"
      matTooltip="{{ actionModel.module + '.UTIL.BUTTONS.DELETE' | translate }}"
      matTooltipPosition="left"
    >
      <i class="fa material-icons red">delete</i>
    </li>

    <!-- CANCEL ACTION-->
    <li
      *ngIf="actionModel.displayCancelButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="cancel()"
      matTooltip="{{ actionModel.module + '.UTIL.BUTTONS.CANCEL' | translate }}"
      matTooltipPosition="left"
    >
      <i class="fa material-icons red">cancel</i>
    </li>

    <!-- DUPLICATE ACTION-->
    <li
      *ngIf="actionModel.displayDuplicateButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="duplicate()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.DUPLICATE' | translate
      }}"
      matTooltipPosition="left"
    >
      <i class="fa material-icons purple">file_copy</i>
    </li>

    <!-- DUPLICATE MASS ACTION-->
    <li
      *ngIf="actionModel.displayDuplicateMasseButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="duplicateMasse()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.DUPLICATE_MASSE' | translate
      }}"
      matTooltipPosition="left"
    >
      <i class="fa material-icons purple">layers</i>
    </li>

    <!-- DUPLICATE MASS ACTION-->
    <li
      *ngIf="actionModel.displayUseAsModel"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="useAsModel()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.USE_AS_MODEL' | translate
      }}"
      matTooltipPosition="left"
    >
      <i class="fa material-icons more-dark-blue">style</i>
    </li>

    <li
      *ngIf="actionModel.displayCreateContractButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="!isAlreadyClick() ? createContract() : null"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.CREATE_CONTRACT' | translate
      }}"
      matTooltipPosition="left"
    >
      <i class="fa material-icons more-dark-blue">account_balance</i>
    </li>

    <li
      *ngIf="actionModel.displayCreateDuplicateButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="createDuplicate()"
      matTooltip="{{ actionModel.module + '.UTIL.BUTTONS.SAVE' | translate }}"
      matTooltipPosition="left"
    >
      <i class="fa fa-floppy-o success" aria-hidden="true" disabled></i>
    </li>

    <!-- EDIT ACTION-->
    <li
      *ngIf="actionModel.displayEditButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="edit()"
      matTooltip="{{ actionModel.module + '.UTIL.BUTTONS.UPDATE' | translate }}"
      matTooltipPosition="left"
    >
      <i class="fa material-icons warning">mode_edit</i>
    </li>

    <!-- SEND NOD NOTIFICATION -->
    <li
      *ngIf="actionModel.displaySendNodNotification"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="sendNodNotification()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.SEND_NOTIFICATION' | translate
      }}"
      matTooltipPosition="left"
      id=""
    >
      <i
        class="fa material-icons white"
        style="color: palevioletred !important;"
      >email</i
      >
    </li>

    <!-- EXCEL IMPORT BUTTON -->
    <li
      *ngIf="actionModel.displayExcelImport"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="excelImport()"
      matTooltip="{{ 'UTIL.BUTTONS.EXCEL_IMPORT' | translate }}"
      matTooltipPosition="left"
      id="excelImport">
      <i class="fa material-icons success">cloud_upload</i>
    </li>

    <!-- POST ACTION-->
    <li
      *ngIf="actionModel.displayPostButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="!isAlreadyClick() ? post() : null"
      matTooltip="{{ actionModel.module + '.UTIL.BUTTONS.SAVE' | translate }}"
      matTooltipPosition="left"
    >
      <i class="fa material-icons success">save</i>
    </li>

    <!-- UPDATE ACTION-->
    <li
      *ngIf="actionModel.displayUpdateButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="put()"
      matTooltip="{{ actionModel.module + '.UTIL.BUTTONS.SAVE' | translate }}"
      matTooltipPosition="left"
    >
      <i class="fa material-icons success">save</i>
    </li>

    <!-- ADD BUTTON -->
    <li
      *ngIf="actionModel.displayAddButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="add()"
      matTooltip="{{ actionModel.module + '.UTIL.BUTTONS.ADD' | translate }}"
      matTooltipPosition="left"
      id="addActionButton"
    >
      <i class="fa material-icons success">add</i>
    </li>

    <!-- ADD IN SESSION BUTTON -->
    <li
      *ngIf="actionModel.displayAddInSessionButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="addInSession()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.ADD_IN_SESSION' | translate
      }}"
      matTooltipPosition="left"
      id="addInSessionActionButton"
    >
      <i class="fa material-icons dark-blue">check</i>
    </li>

    <!-- UPDATE IN SESSION BUTTON -->
    <li
      *ngIf="actionModel.displayUpdateInSessionButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="updateInSession()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.UPDATE_IN_SESSION' | translate
      }}"
      matTooltipPosition="left"
      id="updateInSessionActionButton"
    >
      <i class="fa material-icons dark-blue">check</i>
    </li>

    <!-- CREATION GROUP BUTTON -->
    <li
      *ngIf="actionModel.displaySignButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="setGroup()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.CREATE_GROUP' | translate
      }}"
      matTooltipPosition="left"
      id="signActionButton"
    >
      <i class="fa material-icons purple">style</i>
      <!--<button mat-icon-button class="mati mati-group success mat-36" aria-hidden="true"></button>-->
    </li>

    <!-- SIGN BUTTON -->
    <li
      *ngIf="actionModel.displayProtectButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="protect()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.PROTECT' | translate
      }}"
      matTooltipPosition="left"
      id="protectButton"
    >
      <i class="fa material-icons dark-blue">verified_user</i>
      <!--<button mat-icon-button class="mati mati-group success mat-36" aria-hidden="true"></button>-->
    </li>

    <!-- GENERATE PDF BUTTON -->
    <li
      *ngIf="actionModel.displayDownloadDraftPdfButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="downloadDraftPdf()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.DOWNLOAD_DRAFT' | translate
      }}"
      matTooltipPosition="left"
      id="downloadDraftPdfButton"
    >
      <i class="fa material-icons white" style="color: #007bff !important;"
      >file_download</i
      >
    </li>

    <!-- GENERATE PDF BUTTON -->
    <li
      *ngIf="actionModel.displayPdfButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="pdf()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.GENERATE_PDF' | translate
      }}"
      matTooltipPosition="left"
      id="pdfButton"
    >
      <i class="fa material-icons white" style="color: #ff1f3f !important;"
      >cloud_upload</i
      >
    </li>

    <!-- GENERATE PDF BUTTON -->
    <li
      *ngIf="actionModel.displayDownloadPdfButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="downloadPdf()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.DOWNLOAD' | translate
      }}"
      matTooltipPosition="left"
      id="downloadPdfButton"
    >
      <i class="fa material-icons white" style="color: darkgreen !important;"
      >file_download</i
      >
    </li>

    <!-- DISPLAY WORKFLOW BUTTON -->
    <li
      *ngIf="actionModel.displayWorkflowButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="displayWorkflow()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.WORKFLOW' | translate
      }}"
      matTooltipPosition="left"
      id="displayWorkflowId"
    >
      <i class="fa material-icons white" style="color: #007bff !important;"
      >repeat</i
      >
    </li>

    <!-- GENERATE NOD BUTTON -->
    <li
      *ngIf="actionModel.displayNodButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="displayNod()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.DOWNLOAD_NOD' | translate
      }}"
      matTooltipPosition="left"
      id="downloadNodButton"
    >
      <i class="fa material-icons white" style="color: #007bff !important;"
      >file_download</i
      >
    </li>

    <!-- DISPLAY REFUSE BUTTON -->
    <li
      *ngIf="actionModel.displayRefuseButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="refuse()"
      matTooltip="{{ actionModel.module + '.UTIL.BUTTONS.REFUSE' | translate }}"
      matTooltipPosition="left"
      id="refuseId"
    >
      <i class="fa material-icons red">block</i>
    </li>
    <!-- DISPLAY CLOSING DATE BUTTON -->
    <li
      *ngIf="actionModel.displayClosingDate"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="closingDate()"
      matTooltip="{{
        actionModel.module + '.UTIL.ACCOUNTING_CLOSING.CONSULT.POST' | translate
      }}"
      matTooltipPosition="left"
      id="closingDateId"
    >
      <i class="fa material-icons red">block</i>
    </li>

    <!-- DISPLAY DOWNLOAD XLSX BUTTON -->
    <li
      *ngIf="actionModel.displayDownloadXlsxButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="downloadXlsx()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.DOWNLOAD_XLSX' | translate
      }}"
      matTooltipPosition="left"
      id="downloadXlsxButton"
    >
      <i class="fa material-icons white" style="color: darkgreen !important;"
      >file_download</i
      >
    </li>
    <!-- DISPLAY SECOND DOWNLOAD XLSX BUTTON -->
    <li
      *ngIf="actionModel.displaySecondDownloadXlsxButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="downloadSecondXlsx()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.DOWNLOAD_SECOND_XLSX' | translate
      }}"
      matTooltipPosition="left"
      id="downloadSecondXlsxButton"
    >
      <i class="fa material-icons white" style="color: darkgreen !important;"
      >file_download</i
      >
    </li>
    <!-- SAVE CRITERIA BUTTON -->
    <li
      *ngIf="actionModel.saveCriteria"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="post()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.SAVE_CRITERIA' | translate
      }}"
      matTooltipPosition="left"
      id="saveCriteria"
    >
      <i class="fa material-icons success">playlist_add</i>
    </li>

    <li
      *ngIf="actionModel.displayCancelTurnoverButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="cancelTurnover()"
      matTooltip="{{ 'UTIL.BUTTONS.CANCEL_TURNOVER' | translate }}"
      matTooltipPosition="left"
      positionStyle="fixed"
      id="displayCancelTurnoverButton"
    >
      <i class="fa material-icons red" style="color: white !important;"
      >undo</i
      >
    </li>

    <li
      *ngIf="actionModel.displaySetOkFacturationButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="setOkFacturation()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.SET_OK_FACTURATION' | translate
      }}"
      matTooltipPosition="left"
      positionStyle="fixed"
      id="displaySetOkFacturationButton"
    >
      <i class="fa material-icons success">save</i>
    </li>

    <li
      *ngIf="actionModel.displaySGenerateInvoiceAllButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="downloadInvoiceDocumentAll()"
      matTooltip="{{ 'BUTTONS.GENERATE_INVOICE_DOCUMENT_ALL' | translate }}"
      matTooltipPosition="left"
      id="displaySGenerateInvoiceAllButton"
    >
      <i class="fa material-icons white" style="color: darkgreen !important;"
      >save</i
      >
    </li>
    <!-- TURNOVER SAVE-->
    <li
      *ngIf="actionModel.displayTurnoverSaveButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="!isAlreadyClick() ? put() : null"
      matTooltip="{{
        'WORK.TURNOVER_SEARCH.BUTTON.ACCOUNTING_VALIDATION' | translate
      }}"
      matTooltipPosition="left"
    >
      <i class="fa material-icons success">check</i>
    </li>

    <li
      *ngIf="actionModel.displayTakeTurnoverButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="takeTurnoverValidation()"
      matTooltip="{{ 'BUTTONS.TAKE_TURNOVER_VALIDATION' | translate }}"
      matTooltipPosition="left"
      id="displayTakeTurnerOverButton"
    >
      <i class="fa material-icons success">cloud_upload</i>
    </li>
    <!-- APPLY CRITERIA BUTTON -->
    <li
      *ngIf="actionModel.applyCriteria"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="put()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.APPLY_CRITERIA' | translate
      }}"
      matTooltipPosition="left"
      id="applyCriteria"
    >
      <i class="fa material-icons saddlebrown">playlist_add_check</i>
    </li>


    <!-- IMPORT DOCUMENT BUTTON -->
    <li
      *ngIf="actionModel.displayImportDocument"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="importDocument()"
      matTooltip="{{ 'UTIL.BUTTONS.IMPORT_DOCUMENT' | translate }}"
      matTooltipPosition="left"
      positionStyle="fixed"
      id="importDocument"
    >
      <i class="fa material-icons saddlebrown">cloud_upload</i>
    </li>

    <!-- EXTRACT POST LINE BUTTON -->
    <li
      *ngIf="actionModel.displayPostLineExtraction"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="postLineExtraction()"
      matTooltip="{{
        actionModel.module + '.UTIL.BUTTONS.EXTRACT_POST_LINE_XLSX' | translate
      }}"
      matTooltipPosition="left"
      id="postLineExtraction"
    >
      <i class="fa material-icons white">format_list_bulleted</i>
    </li>

    <!-- IMPORT DOCUMENT BUTTON -->
    <li
      *ngIf="actionModel.displaySettingsButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="settings()"
      matTooltip="{{ 'UTIL.BUTTONS.SETTINGS' | translate }}"
      matTooltipPosition="left"
      positionStyle="fixed">
      <i class="fa material-icons warning">settings</i>
    </li>

    <!-- IMPORT DOCUMENT BUTTON -->
    <li
      *ngIf="actionModel.displaySearchButton"
      [ngClass]="{ show: show }"
      class="action-item animate"
      (click)="search()"
      matTooltip="{{ 'UTIL.BUTTONS.SEARCH' | translate }}"
      matTooltipPosition="left"
      positionStyle="fixed">
      <i class="fa material-icons dark-blue">search</i>
    </li>

    <li
      (mouseenter)="mouseEnter()"
      class="action"
      [ngClass]="{ 'on-hover': state === 'in' }"
    >
      <i *ngIf="state === 'in'" class="fa material-icons active-action"
      >keyboard_arrow_up</i
      >
      <i *ngIf="state === 'out'" class="fa material-icons interaction">add</i>
    </li>
  </ul>
</div>
